export const I18nKeys = {
  global: {
    indexTitle: 'global.indexTitle',
    tipsTitle: 'global.tipsTitle',
    confirmButtonText: 'global.confirmButtonText',
    cancelButtonText: 'global.cancelButtonText',
    day: 'global.day',
    people: 'global.people',
    bindButtonText: 'global.bindButtonText',
    help: 'global.help',
    manageSubscription: 'global.manageSubscription',
    coupon: 'global.coupon',
    deleteMessage: 'global.deleteMessage',
    deleteButtonText: 'global.deleteButtonText',
    renameButtonText: 'global.renameButtonText',
    downloadButtonText: 'global.downloadButtonText',
    install: 'global.install',
    paste: 'global.paste',
    phoneNumberLabel: 'global.phoneNumberLabel',
    verificationCodeLabel: 'global.verificationCodeLabel',
    sendButtonText: 'global.sendButtonText',
    saveButtonText: 'global.saveButtonText',
    download: 'global.download',
    complete: 'global.complete',
    adjustButtonText: 'global.adjustButtonText',
    eraser: 'global.eraser',
    undo: 'global.undo',
    redo: 'global.redo',
    clear: 'global.clear',
    noDataMessage: 'global.noDataMessage',
    loading: 'global.loading',
    customize: 'global.customize',
    referenceImage: 'global.referenceImage',
    styleImage: 'global.styleImage',
    high: 'global.high',
    middle: 'global.middle',
    low: 'global.low',
    big: 'global.big',
    small: 'global.small',
    select: 'global.select',
    upload: 'global.upload',
    colon: 'global.colon',
    uploadDesc: 'global.uploadDesc',
    generate: 'global.generate',
    preview: 'global.preview',
    magic: 'global.magic',
    add: 'global.add',
    subtract: 'global.subtract',
    brush: 'global.brush',
    part: 'global.part',
    commonlyUsed: 'global.commonlyUsed',
    recommend: 'global.recommend',
    termsOfService: 'global.termsOfService',
    billingSupport: 'global.billingSupport',
    userAgreement: 'global.userAgreement',
    privacyStatement: 'global.privacyStatement',
    wechat: 'global.wechat',
    xiaohongshu: 'global.xiaohongshu',
    downloadClient: 'global.downloadClient',
    ok: 'global.ok',
    and: 'global.and',
    language: 'global.language',
    copy: 'global.copy',
    copyLink: 'global.copyLink',
    signupTitle: 'global.signupTitle',
    signupTitleSuffix: 'global.signupTitleSuffix',
    recentsTitle: 'global.recentsTitle',
    projectNameTitle: 'global.projectNameTitle',
    nextStep: 'global.nextStep',
    accept: 'global.accept',
    reject: 'global.reject',
    about: 'global.about',
    subscribeToNews: 'global.subscribeToNews',
    subscribeToNewsDesc: 'global.subscribeToNewsDesc',
    agree: 'global.agree',
    deny: 'global.deny',
    close: 'global.close',
    skip: 'global.skip',
    iKnow: 'global.iKnow',
    modelSelection: 'global.modelSelection',
    account: 'global.account',
    password: 'global.password',
    login: 'global.login',
    upgrade: 'global.upgrade',
    modeSelection: 'global.modeSelection',
    prompt: 'global.prompt'
  },
  login: {
    success: 'login.success',
    closeWindow: 'login.closeWindow'
  },
  update: {
    updateDialogTitle: 'update.updateDialogTitle',
    updateDialogMessage: 'update.updateDialogMessage',
    updateDialogCurrentVersion: 'update.updateDialogCurrentVersion',
    updateDialogNewVersion: 'update.updateDialogNewVersion',
    updateDialogCancelButtonText: 'update.updateDialogCancelButtonText',
    updateDialogUpdateButtonText: 'update.updateDialogUpdateButtonText',
    updateDialogUpdateButtonLoadingText: 'update.updateDialogUpdateButtonLoadingText'
  },
  updateError: {
    updateErrorDialogTitle: 'updateError.updateErrorDialogTitle',
    updateErrorDialogMessage: 'updateError.updateErrorDialogMessage',
    updateErrorDialogButtonText: 'updateError.updateErrorDialogButtonText'
  },
  updateProgress: {
    updateProgressDialogTitle: 'updateProgress.updateProgressDialogTitle'
  },
  system: {
    updateTip: 'system.updateTip',
    updateMessage: 'system.updateMessage',
    drawingDownMessage: 'system.drawingDownMessage',
    bonjourInstallTitle: 'system.bonjourInstallTitle',
    bonjourInstallMessage1: 'system.bonjourInstallMessage1',
    bonjourInstallMessage2: 'system.bonjourInstallMessage2',
    bonjourInstallMessage3: 'system.bonjourInstallMessage3',
    bonjourUnavailableTitle: 'system.bonjourUnavailableTitle',
    bonjourUnavailableMessage1: 'system.bonjourUnavailableMessage1',
    bonjourUnavailableMessage2: 'system.bonjourUnavailableMessage2',
    bonjourUnavailableMessage3: 'system.bonjourUnavailableMessage3',
    bonjourUnavailableMessage4: 'system.bonjourUnavailableMessage4',
    bonjourUnavailableMessage4Local: 'system.bonjourUnavailableMessage4Local',
    bonjourStartTitle: 'system.bonjourStartTitle',
    bonjourStartMessage1: 'system.bonjourStartMessage1',
    bonjourStartMessage2: 'system.bonjourStartMessage2',
    bonjourStartMessage3: 'system.bonjourStartMessage3',
    bonjourStartMessage4: 'system.bonjourStartMessage4',
    bonjourStartMessage5: 'system.bonjourStartMessage5',
    bonjourStartMessage6: 'system.bonjourStartMessage6',
    bonjourStartMessage7: 'system.bonjourStartMessage7',
    bonjourStartMessage7Local: 'system.bonjourStartMessage7Local',
    bonjourStartText: 'system.bonjourStartText',
    bonjourUnavailable: 'system.bonjourUnavailable',
    bonjourDownload: 'system.bonjourDownload',
    revoUninstaller: 'system.revoUninstaller',
    forceUninstallMessage: 'system.forceUninstallMessage',
    guideButtonText: 'system.guideButtonText',
    noImageMessage: 'system.noImageMessage',
    aboutUsTitle: 'system.aboutUsTitle',
    weChatPublicAccountTitle: 'system.weChatPublicAccountTitle',
    error400: 'system.error400',
    error403: 'system.error403',
    error404: 'system.error404',
    error408: 'system.error408',
    error500: 'system.error500',
    error501: 'system.error501',
    error502: 'system.error502',
    error503: 'system.error503',
    error504: 'system.error504',
    copySuccess: 'system.copySuccess',
    copyError: 'system.copyError',
    browserTips: 'system.browserTips',
    serviceStopMessage: 'system.serviceStopMessage',
    renewalReminderMessage: 'system.renewalReminderMessage',
    paymentLink: 'system.paymentLink',
    updateTipsMessage: 'system.updateTipsMessage',
    osVersionNotSupportedMessageWindows: 'system.osVersionNotSupportedMessageWindows',
    osVersionNotSupportedMessageMacOS: 'system.osVersionNotSupportedMessageMacOS',
    updatedDownloadMessage: 'system.updatedDownloadMessage',
    receiverConnectErrorMessage: 'system.receiverConnectErrorMessage',
    receiverStartErrorMessage: 'system.receiverStartErrorMessage',
    macOSVersionErrorMessage: 'system.macOSVersionErrorMessage',
    airplayRTPErrorMessage: 'system.airplayRTPErrorMessage',
    networkDisconnectedMessage: 'system.networkDisconnectedMessage',
    networkReconnectedMessage: 'system.networkReconnectedMessage',
    slogan1: 'system.slogan1',
    slogan2: 'system.slogan2',
    slogan3: 'system.slogan3',
    slogan4: 'system.slogan4',
    slogan5: 'system.slogan5',
    slogan6: 'system.slogan6',
    networkErrorMessage: 'system.networkErrorMessage',
    serverErrorMessage: 'system.serverErrorMessage',
    languageChangeMessage: 'system.languageChangeMessage',
    downloadAppMessage: 'system.downloadAppMessage',
    downloadButtonTextMac: 'system.downloadButtonTextMac',
    downloadButtonTextWindows: 'system.downloadButtonTextWindows',
    consentTitle: 'system.consentTitle',
    consentTips: 'system.consentTips',
    aboutTitle: 'system.aboutTitle',
    currentVersion: 'system.currentVersion',
    newVersion: 'system.newVersion',
    copyright: 'system.copyright',
    copyrightLocal: 'system.copyrightLocal',
    checkUpdateButtonText: 'system.checkUpdateButtonText',
    updateButtonText: 'system.updateButtonText',
    noUpdateMessage: 'system.noUpdateMessage',
    updateFailMessage: 'system.updateFailMessage',
    appDownloadGuideTitle: 'system.appDownloadGuideTitle',
    appDownloadGuideSubTitle: 'system.appDownloadGuideSubTitle',
    realtimeDesignGuideTitle: 'system.realtimeDesignGuideTitle',
    realtimeDesignGuideSubTitle1: 'system.realtimeDesignGuideSubTitle1',
    realtimeDesignGuideSubTitle2: 'system.realtimeDesignGuideSubTitle2',
    freeCountLimitDialogTitle: 'system.freeCountLimitDialogTitle',
    freeCountLimitDialogDesc: 'system.freeCountLimitDialogDesc',
    freeCountLimitDialogDescMobile: 'system.freeCountLimitDialogDescMobile',
    imageSizeTooLarge: 'system.imageSizeTooLarge'
  },
  error: {
    invitationCodeUsed: 'error.invitationCodeUsed',
    invitationCodeInvalid: 'error.invitationCodeInvalid',
    networkErrorTitle: 'error.networkErrorTitle',
    networkErrorMessage: 'error.networkErrorMessage',
    retryButtonText: 'error.retryButtonText',
    upscaleScaleError: 'error.upscaleScaleError',
    campaignSystemError: 'error.campaignSystemError',
    campaignUserAuthError: 'error.campaignUserAuthError',
    campaignParamError: 'error.campaignParamError',
    campaignQueryError: 'error.campaignQueryError',
    campaignNotCompleted: 'error.campaignNotCompleted',
    campaignRewardAlreadyClaimed: 'error.campaignRewardAlreadyClaimed',
    campaignCouponNotAvailable: 'error.campaignCouponNotAvailable',
    campaignUseCoupon: 'error.campaignUseCoupon',
    campaignAssignCoupon: 'error.campaignAssignCoupon',
    userGoogleAuthFail: 'error.userGoogleAuthFail',
    userNotSupportLoginType: 'error.userNotSupportLoginType',
    userSystemError: 'error.userSystemError',
    userLoginError: 'error.userLoginError'
  } as Record<string, string>,
  account: {
    logoutMessage: 'account.logoutMessage',
    logoutButtonText: 'account.logoutButtonText',
    bindPhoneTitle: 'account.bindPhoneTitle',
    bindPhoneSuccessMessage: 'account.bindPhoneSuccessMessage',
    bindPhoneTips: 'account.bindPhoneTips',
    bindPhoneEmptyNumberMessage: 'account.bindPhoneEmptyNumberMessage',
    bindPhoneErrorNumberMessage: 'account.bindPhoneErrorNumberMessage',
    bindPhoneVerificationCodeEmptyMessage: 'account.bindPhoneVerificationCodeEmptyMessage',
    getInvitationCodeErrorMessage: 'account.getInvitationCodeErrorMessage',
    memberExpireAtFormat: 'account.memberExpireAtFormat',
    trialDuration: 'account.trialDuration',
    trialDurationYearlyCoupon: 'account.trialDurationYearlyCoupon',
    trialExtraText: 'account.trialExtraText',
    headerGiftText: 'account.headerGiftText',
    headerGiftTextLocal: 'account.headerGiftTextLocal',
    headerOneDayGiftText: 'account.headerOneDayGiftText',
    headerSubscribeGiftText: 'account.headerSubscribeGiftText',
    invitePopoverTitle: 'account.invitePopoverTitle',
    invitePopoverDescTips: 'account.invitePopoverDescTips',
    invitePopoverMark: 'account.invitePopoverMark',
    invitePopoverMarkLocal: 'account.invitePopoverMarkLocal',
    invitePopoverDesc: 'account.invitePopoverDesc',
    invitePopoverDescLocal: 'account.invitePopoverDescLocal',
    invitePopoverCodeShareTitle: 'account.invitePopoverCodeShareTitle',
    invitePopoverCodeCopyTitle: 'account.invitePopoverCodeCopyTitle',
    invitePopoverShareCountText: 'account.invitePopoverShareCountText',
    invitePopoverSubText: 'account.invitePopoverSubText',
    invitePopoverGiftDaysText: 'account.invitePopoverGiftDaysText',
    invitePopoverGiftDaysTextLocal: 'account.invitePopoverGiftDaysTextLocal',
    invitePopoverBindPhoneMaskText: 'account.invitePopoverBindPhoneMaskText',
    phoneNumber: 'account.phoneNumber',
    noMemberText: 'account.noMemberText',
    memberExpireAt: 'account.memberExpireAt',
    memberUpgradeMainText: 'account.memberUpgradeMainText',
    memberUpgradeMainTextFirst: 'account.memberUpgradeMainTextFirst',
    memberUpgradeSubText: 'account.memberUpgradeSubText',
    memberUpgradeLinkTextActivate: 'account.memberUpgradeLinkTextActivate',
    memberUpgradeLinkTextUpgrade: 'account.memberUpgradeLinkTextUpgrade',
    memberUpgradeLinkTextGet: 'account.memberUpgradeLinkTextGet',
    memberUpgradeLinkTextManage: 'account.memberUpgradeLinkTextManage',
    discordLoginTitle: 'account.discordLoginTitle',
    discordLoginButtonText: 'account.discordLoginButtonText',
    discordLoginSubText1: 'account.discordLoginSubText1',
    discordLoginSubText2: 'account.discordLoginSubText2',
    googleLoginButtonText: 'account.googleLoginButtonText',
    invitePageTitle: 'account.invitePageTitle',
    invitePageNicknamePlaceholder: 'account.invitePageNicknamePlaceholder',
    invitePageInvitationCodePlaceholder: 'account.invitePageInvitationCodePlaceholder',
    invitePageSubmitButtonText: 'account.invitePageSubmitButtonText',
    invitePageTips: 'account.invitePageTips',
    invitePageInvitationCodeInvalid: 'account.invitePageInvitationCodeInvalid',
    hasInvitationCodeText: 'account.hasInvitationCodeText',
    shareInvitationCodeText: 'account.shareInvitationCodeText',
    shareInvitationCodeTextLocal: 'account.shareInvitationCodeTextLocal',
    limitedTitle: 'account.limitedTitle',
    limitedTime: 'account.limitedTime',
    limitedRealtimeDesignTime: 'account.limitedRealtimeDesignTime',
    limitedSubject: 'account.limitedSubject',
    upgradeTitle: 'account.upgradeTitle',
    upgradeSubject: 'account.upgradeSubject',
    upgradeButtonText: 'account.upgradeButtonText',
    mergeAccount: 'account.mergeAccount',
    mergeAccountDesc: 'account.mergeAccountDesc',
    mergeAccountCancel: 'account.mergeAccountCancel',
    recentLoginText: 'account.recentLoginText',
    passwordLoginButtonText: 'account.passwordLoginButtonText',
    usernameErrorMessage: 'account.usernameErrorMessage',
    passwordErrorMessage: 'account.passwordErrorMessage'
  },
  project: {
    recentListTitle: 'project.recentListTitle',
    collectListTitle: 'project.recentListTitle',
    projectListTitle: 'project.projectListTitle',
    emptyMessage1: 'project.emptyMessage1',
    emptyMessage2: 'project.emptyMessage2',
    emptyMessage3: 'project.emptyMessage3',
    emptyMessage4: 'project.emptyMessage4',
    emptyMessage5: 'project.emptyMessage5',
    emptyMessage6: 'project.emptyMessage6',
    emptyMessage7: 'project.emptyMessage7',
    createProjectButtonText: 'project.createProjectButtonText',
    projectNamePlaceholder: 'project.projectNamePlaceholder',
    projectEnterText1: 'project.projectEnterText1',
    projectEnterText2: 'project.projectEnterText2',
    createProjectTip: 'project.createProjectTip'
  },
  image: {
    text2ImageTitle: 'image.text2ImageTitle',
    originalityTitle: 'image.originalityTitle',
    styleExtensionTitle: 'image.styleExtensionTitle',
    styleFuseTitle: 'image.styleFuseTitle',
    tuneTitle: 'image.tuneTitle',
    recolorTitle: 'image.recolorTitle',
    backgroundTitle: 'image.backgroundTitle',
    flowerPatternExpansionTitle: 'image.flowerPatternExpansionTitle',
    aiExpansionTitle: 'image.aiExpansionTitle',
    eraserTitle: 'image.eraserTitle',
    cutoutTitle: 'image.cutoutTitle',
    hdTitle: 'image.hdTitle',
    drawingTitle: 'image.drawingTitle',
    patternTitle: 'image.patternTitle',
    imageCount: 'image.imageCount',
    generateButtonText: 'image.generateButtonText',
    generateButtonSubscribeBoxTitle1: 'image.generateButtonSubscribeBoxTitle1',
    generateButtonSubscribeBoxTitle1Local: 'image.generateButtonSubscribeBoxTitle1Local',
    generateButtonSubscribeBoxTitle2: 'image.generateButtonSubscribeBoxTitle2',
    generateButtonSubscribeBoxDesc1: 'image.generateButtonSubscribeBoxDesc1',
    generateButtonSubscribeBoxDesc2: 'image.generateButtonSubscribeBoxDesc2',
    generateButtonSubscribeBoxButtonText1: 'image.generateButtonSubscribeBoxButtonText1',
    generateButtonSubscribeBoxButtonText2: 'image.generateButtonSubscribeBoxButtonText2',
    generateButtonSubscribeBoxButtonText2Local: 'image.generateButtonSubscribeBoxButtonText2Local',
    originalSizeText: 'image.originalSizeText',
    uploadImageButtonText: 'image.uploadImageButtonText',
    uploadPatternButtonText: 'image.uploadPatternButtonText',
    editMaskButtonText: 'image.editMaskButtonText',
    removeMaskButtonText: 'image.removeMaskButtonText',
    imageUploaderDesc: 'image.imageUploaderDesc',
    generatePreviewText: 'image.generatePreviewText',
    previewListHelpMessage1: 'image.previewListHelpMessage1',
    previewListHelpMessage2: 'image.previewListHelpMessage2',
    clearPreviewButtonText: 'image.clearPreviewButtonText',
    segmentErrorMessage: 'image.segmentErrorMessage',
    generatingMessage: 'image.generatingMessage',
    previewWaitingMessage: 'image.previewWaitingMessage',
    previewFailedMessage: 'image.previewFailedMessage',
    imageInQueueMessage: 'image.imageInQueueMessage',
    imageNotVerifyMessage: 'image.imageNotVerifyMessage',
    saveImageButtonText: 'image.saveImageButtonText',
    deleteTmpImageButtonText: 'image.deleteTmpImageButtonText',
    previewImageInfoText: 'image.previewImageInfoText',
    promptDefaultPlaceholder: 'image.promptDefaultPlaceholder',
    promptDefaultPlaceholder2: 'image.promptDefaultPlaceholder2',
    promptDefaultPlaceholder3: 'image.promptDefaultPlaceholder3',
    promptDefaultPlaceholder4: 'image.promptDefaultPlaceholder4',
    removeBgErrorMessage: 'image.removeBgErrorMessage',
    removeBgButtonText: 'image.removeBgButtonText',
    removeBgLoadingMessage: 'image.removeBgLoadingMessage',
    cropTip1: 'image.cropTip1',
    cropTip2: 'image.cropTip2',
    diyModelText: 'image.diyModelText',
    commonModelText: 'image.commonModelText',
    exclusiveModelText: 'image.exclusiveModelText',
    promptTitle: 'image.promptTitle',
    promptTitle2: 'image.promptTitle2',
    promptTitle3: 'image.promptTitle3',
    promptTitle4: 'image.promptTitle4',
    promptInputTitle: 'image.promptInputTitle',
    selectModelTitle: 'image.selectModelTitle',
    referenceStrengthLabel: 'image.referenceStrengthLabel',
    modelSettingTitle: 'image.modelSettingTitle',
    advancedSettingsTitle: 'image.advancedSettingsTitle',
    negativePromptTitle: 'image.negativePromptTitle',
    negativePromptPlaceholder: 'image.negativePromptPlaceholder',
    generateCountTitle: 'image.generateCountTitle',
    cleanerTitle: 'image.cleanerTitle',
    maskSwitchViewButtonText: 'image.maskSwitchViewButtonText',
    regenerateButtonText: 'image.regenerateButtonText',
    imageLoadingMessage: 'image.imageLoadingMessage',
    maskGenerateFailedMessage: 'image.maskGenerateFailedMessage',
    maskPreviewDialogConfirmButtonText1: 'image.maskPreviewDialogConfirmButtonText1',
    maskPreviewDialogConfirmButtonText2: 'image.maskPreviewDialogConfirmButtonText2',
    maskPreviewDialogCancelButtonText: 'image.maskPreviewDialogCancelButtonText',
    objectRemovalDialogCancelButtonText: 'image.objectRemovalDialogCancelButtonText',
    objectRemovalFailedMessage: 'image.objectRemovalFailedMessage',
    magicMaskGenerateFailedMessage: 'image.magicMaskGenerateFailedMessage',
    partMaskDialogTitle: 'image.partMaskDialogTitle',
    imageAnalyzingMessage: 'image.imageAnalyzingMessage',
    cutout: 'image.cutoutTitle',
    maskDialogConfirmButtonText1: 'image.maskDialogConfirmButtonText1',
    maskDialogConfirmButtonText2: 'image.maskDialogConfirmButtonText2',
    maskDialogConfirmTip: 'image.maskDialogConfirmTip',
    rangeOfChangeLabel: 'image.rangeOfChangeLabel',
    lesser: 'image.lesser',
    more: 'image.more',
    disableModelDesc: 'image.disableModelDesc',
    generateFailedMessage: 'image.generateFailedMessage',
    taskNotEnoughTip: 'image.taskNotEnoughTip',
    saveTip1: 'image.saveTip1',
    saveTip2: 'image.saveTip2',
    promptButtonText1: 'image.promptButtonText1',
    promptButtonText2: 'image.promptButtonText2',
    promptButtonMessage: 'image.promptButtonMessage',
    promptButtonFailMessage: 'image.promptButtonFailMessage',
    colorMatchTitle: 'image.colorMatchTitle',
    colorMatchSubject: 'image.colorMatchSubject',
    colorMatchDesc: 'image.colorMatchDesc',
    realTimeDesignDesc: 'image.realTimeDesignDesc',
    patternExpansionSize: 'image.patternExpansionSize',
    patternExpansionSizeSmall: 'image.patternExpansionSizeSmall',
    patternExpansionSizeMedium: 'image.patternExpansionSizeMedium',
    patternExpansionSizeLarge: 'image.patternExpansionSizeLarge',
    flowerPatternExpansionStep1: 'image.flowerPatternExpansionStep1',
    flowerPatternExpansionStep2: 'image.flowerPatternExpansionStep2',
    flowerPatternExpansionStep3: 'image.flowerPatternExpansionStep3',
    maskCreateText: 'image.maskCreateText',
    highDefinitionRepair: 'image.highDefinitionRepair',
    consistency: 'image.consistency',
    patternDescriptionTitle: 'image.patternDescriptionTitle',
    patternExtractionTitle: 'image.patternExtractionTitle',
    patternExtractionTip: 'image.patternExtractionTip',
    promptTemplate: 'image.promptTemplate',
    patternExtractionTipTitle1: 'image.patternExtractionTipTitle1',
    patternExtractionTipDesc1: 'image.patternExtractionTipDesc1',
    patternExtractionTipTitle2: 'image.patternExtractionTipTitle2',
    patternExtractionTipDesc2: 'image.patternExtractionTipDesc2',
    patternExtractionTipTitle3: 'image.patternExtractionTipTitle3',
    patternExtractionTipDesc3: 'image.patternExtractionTipDesc3',
    clothingDescription: 'image.clothingDescription',
    materialDescription: 'image.materialDescription',
    clothingDescriptionPlaceholder: 'image.clothingDescriptionPlaceholder',
    patternDescriptionPlaceholder: 'image.patternDescriptionPlaceholder',
    materialConversionPlaceholder: 'image.materialConversionPlaceholder',
    generationQualityTitle: 'image.generationQualityTitle'
  },
  cleaner: {
    cleaner: 'cleaner.cleaner',
    maskDialogTitle: 'cleaner.maskDialogTitle',
    maskDesc: 'cleaner.maskDesc'
  },
  drawing: {
    generatingMessage: 'drawing.generatingMessage',
    startDrawingMessage: 'drawing.startDrawingMessage',
    waitingScreenMessage: 'drawing.waitingScreenMessage',
    canvasCropperGuideMessage: 'drawing.canvasCropperGuideMessage',
    startDrawingButtonText: 'drawing.startDrawingButtonText',
    stopDrawingButtonText: 'drawing.stopDrawingButtonText',
    videoNotSupportMessage: 'drawing.videoNotSupportMessage',
    canvasGuideMessage1: 'drawing.canvasGuideMessage1',
    canvasGuideMessage2: 'drawing.canvasGuideMessage2',
    castScreenGuideMessage1: 'drawing.castScreenGuideMessage1',
    castScreenGuideMessage2: 'drawing.castScreenGuideMessage2',
    castScreenGuideMessage2After: 'drawing.castScreenGuideMessage2After',
    castScreenGuideMessage3: 'drawing.castScreenGuideMessage3',
    castScreenGuideMessage4: 'drawing.castScreenGuideMessage4',
    screenPreviewTitle: 'drawing.screenPreviewTitle',
    reCropButtonText: 'drawing.reCropButtonText'
  },
  styleExtension: {
    styleExtensionTitle: 'styleExtension.styleExtensionTitle',
  },
  hd: {
    hdTools: 'hd.hdTools',
    scaleTitle: 'hd.scaleTitle',
    imageClaritySD: 'hd.imageClaritySD',
    imageClarityHD: 'hd.imageClarityHD',
    imageClarityUHD: 'hd.imageClarityUHD',
    imageClarityTextSD: 'hd.imageClarityTextSD',
    imageClarityTextHD: 'hd.imageClarityTextHD',
    imageClarityTextUHD: 'hd.imageClarityTextUHD',
    generatingMessage: 'hd.generatingMessage'
  },
  matte: {
    matteTools: 'matte.matteTools',
    maskDialogTitle: 'matte.maskDialogTitle',
    maskDesc: 'matte.maskDesc',
    magicLabel: 'matte.magicLabel'
  },
  originality: {
    originalityTitle: 'originality.originalityTitle',
    lineDrawingTitle: 'originality.lineDrawingTitle',
    lineDrawingUploadTitle: 'originality.lineDrawingUploadTitle',
    sampleClothesTitle: 'originality.sampleClothesTitle'
  },
  recolor: {
    recolorTools: 'recolor.recolorTools',
    maskDialogTitle: 'recolor.maskDialogTitle',
    maskDesc: 'recolor.maskDesc',
    colorSelectTitle: 'recolor.colorSelectTitle',
    getColorWarningMessage: 'recolor.getColorWarningMessage'
  },
  styleFusion: {
    referenceImageDialogTitle1: 'styleFusion.referenceImageDialogTitle1'
  },
  background: {
    maskDialogTitle: 'background.maskDialogTitle',
    maskDesc: 'background.maskDesc',
    backgroundDialogTitle: 'background.backgroundDialogTitle',
    backgroundDescTitle: 'background.backgroundDescTitle',
    promptInputPlaceholder: 'background.promptInputPlaceholder',
    referenceBackgroundTitle: 'background.referenceBackgroundTitle',
    intelligentFillLightLabel: 'background.intelligentFillLightLabel',
    backgroundGenerateTimeoutMessage: 'background.backgroundGenerateTimeoutMessage',
    backgroundGenerateFailedMessage: 'background.backgroundGenerateFailedMessage',
    addBackgroundTitle: 'background.addBackgroundTitle',
    backgroundSizeTitle: 'background.backgroundSizeTitle',
    effectPreviewMessage: 'background.effectPreviewMessage',
    canvasEmptyMessage: 'background.canvasEmptyMessage'
  },
  text2Image: {
    textExampleMessage1: 'text2Image.textExampleMessage1',
    textExampleMessage2: 'text2Image.textExampleMessage2',
    textExampleMessage3: 'text2Image.textExampleMessage3',
    textExampleMessage4: 'text2Image.textExampleMessage4',
    textExampleMessage5: 'text2Image.textExampleMessage5',
    textExampleMessage6: 'text2Image.textExampleMessage6',
    textExampleMessage7: 'text2Image.textExampleMessage7',
    textExampleMessage8: 'text2Image.textExampleMessage8',
    textExampleMessage9: 'text2Image.textExampleMessage9',
    textExampleMessage10: 'text2Image.textExampleMessage10',
    textExampleMessage11: 'text2Image.textExampleMessage11',
    generationRatioTitle: 'text2Image.generationRatioTitle',
    tryText: 'text2Image.tryText',
    freeProportionText: 'text2Image.freeProportionText'
  },
  tune: {
    maskDialogTitle: 'tune.maskDialogTitle',
    maskDesc: 'tune.maskDesc',
    promptTitle: 'tune.promptTitle'
  },
  expansion: {
    aiExpansion: 'expansion.aiExpansion',
    flowerPatternExpansion: 'expansion.flowerPatternExpansion'
  },
  pattern: {
    maskDialogTitle: 'pattern.maskDialogTitle',
    maskDesc: 'pattern.maskDesc',
    assistImagesTitle: 'pattern.assistImagesTitle',
    pattern: 'pattern.pattern',
    printing: 'pattern.printing',
    patternExtractionTitle: 'pattern.patternExtractionTitle',
    patternExtraction: 'pattern.patternExtraction',
    printingExtraction: 'pattern.printingExtraction',
    patternExtractionDesc: 'pattern.patternExtractionDesc',
    printingExtractionDesc: 'pattern.printingExtractionDesc',
    confirmButtonText: 'pattern.confirmButtonText'
  },
  material: {
    materialConversion: 'material.materialConversion',
    referenceImage: 'material.referenceImage',
    referenceImageDesc: 'material.referenceImageDesc',
    reference: 'material.reference'
  },
  clothes: {
    clothingExtraction: 'clothes.clothingExtraction',
    clothingTypeSelection: 'clothes.clothingTypeSelection',
    tops: 'clothes.tops',
    bottoms: 'clothes.bottoms',
    dress: 'clothes.dress',
    topsAndBottoms: 'clothes.topsAndBottoms',
    shoes: 'clothes.shoes',
    hat: 'clothes.hat',
    package: 'clothes.package',
    stylePicture: 'clothes.stylePicture'
  },
  modelTryOn: {
    modelTryOnTools: 'modelTryOn.modelTryOnTools',
    modelImageDialogTitle1: 'modelTryOn.modelImageDialogTitle1',
    modelImageDialogTitle2: 'modelTryOn.modelImageDialogTitle2',
    maskDesc: 'modelTryOn.maskDesc',
    maskDialogTitle: 'modelTryOn.maskDialogTitle',
    upperBodyTitle: 'modelTryOn.upperBodyTitle',
    dressTitle: 'modelTryOn.dressTitle',
    loadingText: 'modelTryOn.loadingText',
    errorText: 'modelTryOn.errorText',
    upperBodyMaskDialogTitle: 'modelTryOn.upperBodyMaskDialogTitle',
    dressMaskDialogTitle: 'modelTryOn.dressMaskDialogTitle',
    singleMaskDialogTitle: 'modelTryOn.singleMaskDialogTitle',
    single: 'modelTryOn.single',
    multi: 'modelTryOn.multi',
    singleTitle: 'modelTryOn.singleTitle'
  },
  modelFace: {
    modelFaceTools: 'modelFace.modelFaceTools',
    uploadImageTitle: 'modelFace.uploadImageTitle',
    maskDesc: 'modelFace.maskDesc',
    selectModelTitle: 'modelFace.selectModelTitle',
    maskDialogTitle: 'modelFace.maskDialogTitle',
    modelSelectorDesc: 'modelFace.modelSelectorDesc',
    headSize: 'modelFace.headSize'
  },
  diyModel: {
    sex: 'diyModel.sex',
    male: 'diyModel.male',
    female: 'diyModel.female',
    age: 'diyModel.age',
    kid: 'diyModel.kid',
    juvenile: 'diyModel.juvenile',
    adult: 'diyModel.adult',
    youth: 'diyModel.youth',
    middleAged: 'diyModel.middleAged',
    elderly: 'diyModel.elderly',
    color: 'diyModel.color',
    bodyShape: 'diyModel.bodyShape',
    hair: 'diyModel.hair',
    length: 'diyModel.length',
    hairstyle: 'diyModel.hairstyle',
    slenderBody: 'diyModel.slenderBody',
    hourglassBody: 'diyModel.hourglassBody',
    muscularBody: 'diyModel.muscularBody',
    babyFatBody: 'diyModel.babyFatBody',
    shortAndFatBody: 'diyModel.shortAndFatBody',
    curvaceousBody: 'diyModel.curvaceousBody',
    straight: 'diyModel.straight',
    wavy: 'diyModel.wavy',
    curly: 'diyModel.curly',
    braided: 'diyModel.braided',
    naturallyCurly: 'diyModel.naturallyCurly',
    updo: 'diyModel.updo',
    airBangs: 'diyModel.airBangs',
    dreadlocks: 'diyModel.dreadlocks',
    ponytail: 'diyModel.ponytail',
    bald: 'diyModel.bald',
    centerPartedHair: 'diyModel.centerPartedHair',
    bangs: 'diyModel.bangs',
    frontBangs: 'diyModel.frontBangs',
    short: 'diyModel.short',
    long: 'diyModel.long',
    shoulderLength: 'diyModel.shoulderLength',
    extraLongHair: 'diyModel.extraLongHair',
    pixieCut: 'diyModel.pixieCut',
    collarboneLengthHair: 'diyModel.collarboneLengthHair',
    shoulderLengthHair: 'diyModel.shoulderLengthHair',
    waistLengthHair: 'diyModel.waistLengthHair',
    fairSkinWhite: 'diyModel.fairSkinWhite',
    darkSkin: 'diyModel.darkSkin',
    yellowSkin: 'diyModel.yellowSkin',
    asian: 'diyModel.asian',
    european: 'diyModel.european',
    african: 'diyModel.african',
    american: 'diyModel.american',
    middleEastern: 'diyModel.middleEastern'
  },
  maskDialogHelpTip: {
    mask: 'maskDialogHelpTip.mask',
    matte: 'maskDialogHelpTip.matte',
    cutout: 'maskDialogHelpTip.cutout',
    part: 'maskDialogHelpTip.part',
    objectRemoval: 'maskDialogHelpTip.objectRemoval',
  },
  helpTip: {
    helpTitle: 'helpTip.helpTitle',
    discord: 'helpTip.discord',
    helpCenter: 'helpTip.helpCenter',
    beginnerTutorialVideo: 'helpTip.beginnerTutorialVideo',
    advancedTutorials: 'helpTip.advancedTutorials',
    faq: 'helpTip.faq',
    refundPolicy: 'helpTip.refundPolicy',
    contactSupport: 'helpTip.contactSupport'
  },
  subscribe: {
    subscribeTitle: 'subscribe.subscribeTitle',
    subscribeTitleFree: 'subscribe.subscribeTitleFree',
    subscribeTitleFreeLocal: 'subscribe.subscribeTitleFreeLocal',
    person: 'subscribe.person',
    month: 'subscribe.month',
    year: 'subscribe.year',
    currency: 'subscribe.currency',
    currencyLocal: 'subscribe.currencyLocal',
    firstMonthOnlyRenewsAt: 'subscribe.firstMonthOnlyRenewsAt',
    yearlyRenewsAt: 'subscribe.yearlyRenewsAt',
    trialText: 'subscribe.trialText',
    mostPopularText: 'subscribe.mostPopularText',
    noMemberText: 'subscribe.noMemberText',
    subscribeSubText: 'subscribe.subscribeSubText',
    subscribeSubTextFree: 'subscribe.subscribeSubTextFree',
    subscribeSubTextOneTime: 'subscribe.subscribeSubTextOneTime',
    priceNegotiableText: 'subscribe.priceNegotiableText',
    tryThisText: 'subscribe.tryThisText',
    payButtonText1: 'subscribe.payButtonText1',
    payButtonText1Free: 'subscribe.payButtonText1Free',
    payButtonText1FreeLocal: 'subscribe.payButtonText1FreeLocal',
    payButtonText2: 'subscribe.payButtonText2',
    payButtonText3: 'subscribe.payButtonText3',
    payButtonText3Local: 'subscribe.payButtonText3Local',
    payButtonText4: 'subscribe.payButtonText4',
    payButtonText5: 'subscribe.payButtonText5',
    payButtonText6: 'subscribe.payButtonText6',
    payButtonText7: 'subscribe.payButtonText7',
    payMessage1: 'subscribe.payMessage1',
    payMessage2: 'subscribe.payMessage2',
    payMessage3: 'subscribe.payMessage3',
    payMessage3Local: 'subscribe.payMessage3Local',
    payMessage4: 'subscribe.payMessage4',
    payMessage5: 'subscribe.payMessage5',
    payMessage6: 'subscribe.payMessage6',
    payMessage6Local: 'subscribe.payMessage6Local',
    payMessage7: 'subscribe.payMessage7',
    payMessage7Local: 'subscribe.payMessage7Local',
    payMessage8: 'subscribe.payMessage8',
    payMessage9: 'subscribe.payMessage9',
    alipayUpgradeTitle: 'subscribe.alipayUpgradeTitle',
    alipayUpgradeSubText: 'subscribe.alipayUpgradeSubText',
    paySuccessText: 'subscribe.paySuccessText',
    paySubText: 'subscribe.paySubText',
    freeMemberSuccessDesc: 'subscribe.freeMemberSuccessDesc',
    freeMemberSuccessDescLocal: 'subscribe.freeMemberSuccessDescLocal',
    receiveAwardTitle: 'subscribe.receiveAwardTitle',
    receiveAwardTitleTaskGuide: 'subscribe.receiveAwardTitleTaskGuide',
    receiveAwardTitleYearlyCoupon: 'subscribe.receiveAwardTitleYearlyCoupon',
    receiveAwardSubject: 'subscribe.receiveAwardSubject',
    receiveAwardSubjectTaskGuide: 'subscribe.receiveAwardSubjectTaskGuide',
    receiveAwardSubjectTaskGuideLocal: 'subscribe.receiveAwardSubjectTaskGuideLocal',
    receiveAwardSubjectYearlyCoupon1: 'subscribe.receiveAwardSubjectYearlyCoupon1',
    receiveAwardSubjectYearlyCoupon1Local: 'subscribe.receiveAwardSubjectYearlyCoupon1Local',
    receiveAwardSubjectYearlyCoupon2: 'subscribe.receiveAwardSubjectYearlyCoupon2',
    receiveAwardTip: 'subscribe.receiveAwardTip',
    receiveAwardTipYearlyCoupon1: 'subscribe.receiveAwardTipYearlyCoupon1',
    receiveAwardTipYearlyCoupon1Local: 'subscribe.receiveAwardTipYearlyCoupon1Local',
    receiveAwardTipYearlyCoupon2: 'subscribe.receiveAwardTipYearlyCoupon2',
    receiveAwardButtonTextTaskGuide: 'subscribe.receiveAwardButtonTextTaskGuide',
    receiveAwardButtonText: 'subscribe.receiveAwardButtonText',
    receiveAwardButtonTextLocal: 'subscribe.receiveAwardButtonTextLocal',
    receiveAwardButtonTextYearlyCoupon: 'subscribe.receiveAwardButtonTextYearlyCoupon',
    memberTipsTrial: 'subscribe.memberTipsTrial',
    memberTipsPersonal: 'subscribe.memberTipsPersonal',
    memberTipsProfessional: 'subscribe.memberTipsProfessional',
    memberTipsEnterprise: 'subscribe.memberTipsEnterprise',
    memberTipsEnterpriseCustomized: 'subscribe.memberTipsEnterpriseCustomized',
    memberFreeDesc1Label: 'subscribe.memberFreeDesc1Label',
    memberFreeDesc1LabelLocal: 'subscribe.memberFreeDesc1LabelLocal',
    memberFreeDesc1Value: 'subscribe.memberFreeDesc1Value',
    memberFreeDesc1ValueLocal: 'subscribe.memberFreeDesc1ValueLocal',
    memberFreeDesc2Label: 'subscribe.memberFreeDesc2Label',
    memberFreeDesc2LabelLocal: 'subscribe.memberFreeDesc2LabelLocal',
    memberFreeDesc2Value: 'subscribe.memberFreeDesc2Value',
    memberFreeDesc2ValueLocal: 'subscribe.memberFreeDesc2ValueLocal',
    memberFreeDesc3Label: 'subscribe.memberFreeDesc3Label',
    memberFreeDesc3Value: 'subscribe.memberFreeDesc3Value',
    memberFreeDesc4Label: 'subscribe.memberFreeDesc4Label',
    memberFreeDesc4Value: 'subscribe.memberFreeDesc4Value',
    memberDescPersonal1Label: 'subscribe.memberDescPersonal1Label',
    memberDescPersonal1Value: 'subscribe.memberDescPersonal1Value',
    memberDescPersonal2Label: 'subscribe.memberDescPersonal2Label',
    memberDescPersonal2Value: 'subscribe.memberDescPersonal2Value',
    memberDescPersonal3Label: 'subscribe.memberDescPersonal3Label',
    memberDescPersonal3Value: 'subscribe.memberDescPersonal3Value',
    memberDescPersonal4Label: 'subscribe.memberDescPersonal4Label',
    memberDescPersonal4Value: 'subscribe.memberDescPersonal4Value',
    memberDescPersonal5Label: 'subscribe.memberDescPersonal5Label',
    memberDescPersonal5Value: 'subscribe.memberDescPersonal5Value',
    memberDescPersonal6Label: 'subscribe.memberDescPersonal6Label',
    memberDescPersonal6Value: 'subscribe.memberDescPersonal6Value',
    memberDescPersonal7Label: 'subscribe.memberDescPersonal7Label',
    memberDescPersonal7Value: 'subscribe.memberDescPersonal7Value',
    memberDescProfessional1Label: 'subscribe.memberDescProfessional1Label',
    memberDescProfessional1Value: 'subscribe.memberDescProfessional1Value',
    memberDescProfessional2Label: 'subscribe.memberDescProfessional2Label',
    memberDescProfessional2Value: 'subscribe.memberDescProfessional2Value',
    memberDescProfessional3Label: 'subscribe.memberDescProfessional3Label',
    memberDescProfessional3Value: 'subscribe.memberDescProfessional3Value',
    memberDescProfessional4Label: 'subscribe.memberDescProfessional4Label',
    memberDescProfessional4Value: 'subscribe.memberDescProfessional4Value',
    memberDescProfessional5Label: 'subscribe.memberDescProfessional5Label',
    memberDescProfessional5Value: 'subscribe.memberDescProfessional5Value',
    memberDescProfessional6Label: 'subscribe.memberDescProfessional6Label',
    memberDescProfessional6Value: 'subscribe.memberDescProfessional6Value',
    memberDescProfessional7Label: 'subscribe.memberDescProfessional7Label',
    memberDescProfessional7Value: 'subscribe.memberDescProfessional7Value',
    memberDescEnterprise1Label: 'subscribe.memberDescEnterprise1Label',
    memberDescEnterprise1Value: 'subscribe.memberDescEnterprise1Value',
    memberDescEnterprise2Label: 'subscribe.memberDescEnterprise2Label',
    memberDescEnterprise2Value: 'subscribe.memberDescEnterprise2Value',
    memberDescEnterprise3Label: 'subscribe.memberDescEnterprise3Label',
    memberDescEnterprise3Value: 'subscribe.memberDescEnterprise3Value',
    memberDescEnterprise4Label: 'subscribe.memberDescEnterprise4Label',
    memberDescEnterprise4Value: 'subscribe.memberDescEnterprise4Value',
    memberDescEnterprise5Label: 'subscribe.memberDescEnterprise5Label',
    memberDescEnterprise5Value: 'subscribe.memberDescEnterprise5Value',
    memberDescEnterprise6Label: 'subscribe.memberDescEnterprise6Label',
    memberDescEnterprise6Value: 'subscribe.memberDescEnterprise6Value',
    memberDescEnterprise7Label: 'subscribe.memberDescEnterprise7Label',
    memberDescEnterprise7Value: 'subscribe.memberDescEnterprise7Value',
    memberDescEnterprise8Label: 'subscribe.memberDescEnterprise8Label',
    memberDescEnterprise8Value: 'subscribe.memberDescEnterprise8Value',
    memberDescEnterpriseCustomized1Label: 'subscribe.memberDescEnterpriseCustomized1Label',
    memberDescEnterpriseCustomized1Value: 'subscribe.memberDescEnterpriseCustomized1Value',
    memberDescEnterpriseCustomized2Label: 'subscribe.memberDescEnterpriseCustomized2Label',
    memberDescEnterpriseCustomized2Value: 'subscribe.memberDescEnterpriseCustomized2Value',
    memberDescEnterpriseCustomized3Label: 'subscribe.memberDescEnterpriseCustomized3Label',
    memberDescEnterpriseCustomized3Value: 'subscribe.memberDescEnterpriseCustomized3Value',
    memberDescEnterpriseCustomized4Label: 'subscribe.memberDescEnterpriseCustomized4Label',
    memberDescEnterpriseCustomized4Value: 'subscribe.memberDescEnterpriseCustomized4Value',
    memberDescEnterpriseCustomized5Label: 'subscribe.memberDescEnterpriseCustomized5Label',
    memberDescEnterpriseCustomized5Value: 'subscribe.memberDescEnterpriseCustomized5Value',
    memberDescEnterpriseCustomized6Label: 'subscribe.memberDescEnterpriseCustomized6Label',
    memberDescEnterpriseCustomized6Value: 'subscribe.memberDescEnterpriseCustomized6Value',
    memberDescEnterpriseCustomized7Label: 'subscribe.memberDescEnterpriseCustomized7Label',
    memberDescEnterpriseCustomized7Value: 'subscribe.memberDescEnterpriseCustomized7Value',
    memberInvitedOnly: 'subscribe.memberInvitedOnly',
    memberTipsStarter: 'subscribe.memberTipsStarter',
    memberTipsPlus: 'subscribe.memberTipsPlus',
    memberTipsPro: 'subscribe.memberTipsPro',
    memberDescStarter0Label: 'subscribe.memberDescStarter0Label',
    memberDescStarter0Value: 'subscribe.memberDescStarter0Value',
    memberDescStarter1Label: 'subscribe.memberDescStarter1Label',
    memberDescStarter1Value: 'subscribe.memberDescStarter1Value',
    memberDescStarter2Label: 'subscribe.memberDescStarter2Label',
    memberDescStarter2Value: 'subscribe.memberDescStarter2Value',
    memberDescStarter3Label: 'subscribe.memberDescStarter3Label',
    memberDescStarter3Value: 'subscribe.memberDescStarter3Value',
    memberDescStarter4Label: 'subscribe.memberDescStarter4Label',
    memberDescStarter4Value: 'subscribe.memberDescStarter4Value',
    memberDescStarter5Label: 'subscribe.memberDescStarter5Label',
    memberDescStarter5Value: 'subscribe.memberDescStarter5Value',
    memberDescStarter6Label: 'subscribe.memberDescStarter6Label',
    memberDescStarter6Value: 'subscribe.memberDescStarter6Value',
    memberDescStarter7Label: 'subscribe.memberDescStarter7Label',
    memberDescStarter7Value: 'subscribe.memberDescStarter7Value',
    memberDescStarter8Label: 'subscribe.memberDescStarter8Label',
    memberDescStarter9Label: 'subscribe.memberDescStarter9Label',
    memberDescPlus0Label: 'subscribe.memberDescPlus0Label',
    memberDescPlus0Value: 'subscribe.memberDescPlus0Value',
    memberDescPlus1Label: 'subscribe.memberDescPlus1Label',
    memberDescPlus1Value: 'subscribe.memberDescPlus1Value',
    memberDescPlus2Label: 'subscribe.memberDescPlus2Label',
    memberDescPlus2Value: 'subscribe.memberDescPlus2Value',
    memberDescPlus3Label: 'subscribe.memberDescPlus3Label',
    memberDescPlus3Value: 'subscribe.memberDescPlus3Value',
    memberDescPlus4Label: 'subscribe.memberDescPlus4Label',
    memberDescPlus4Value: 'subscribe.memberDescPlus4Value',
    memberDescPlus5Label: 'subscribe.memberDescPlus5Label',
    memberDescPlus5Value: 'subscribe.memberDescPlus5Value',
    memberDescPlus6Label: 'subscribe.memberDescPlus6Label',
    memberDescPlus6Value: 'subscribe.memberDescPlus6Value',
    memberDescPlus7Label: 'subscribe.memberDescPlus7Label',
    memberDescPlus7Value: 'subscribe.memberDescPlus7Value',
    memberDescPlus8Label: 'subscribe.memberDescPlus8Label',
    memberDescPlus9Label: 'subscribe.memberDescPlus9Label',
    memberDescPlus10Label: 'subscribe.memberDescPlus10Label',
    memberDescPro0Label: 'subscribe.memberDescPro0Label',
    memberDescPro0Value: 'subscribe.memberDescPro0Value',
    memberDescPro1Label: 'subscribe.memberDescPro1Label',
    memberDescPro1Value: 'subscribe.memberDescPro1Value',
    memberDescPro2Label: 'subscribe.memberDescPro2Label',
    memberDescPro2Value: 'subscribe.memberDescPro2Value',
    memberDescPro3Label: 'subscribe.memberDescPro3Label',
    memberDescPro3Value: 'subscribe.memberDescPro3Value',
    memberDescPro4Label: 'subscribe.memberDescPro4Label',
    memberDescPro4Value: 'subscribe.memberDescPro4Value',
    memberDescPro5Label: 'subscribe.memberDescPro5Label',
    memberDescPro5Value: 'subscribe.memberDescPro5Value',
    memberDescPro6Label: 'subscribe.memberDescPro6Label',
    memberDescPro6Value: 'subscribe.memberDescPro6Value',
    memberDescPro7Label: 'subscribe.memberDescPro7Label',
    memberDescPro7Value: 'subscribe.memberDescPro7Value',
    memberDescPro8Label: 'subscribe.memberDescPro8Label',
    memberDescPro9Label: 'subscribe.memberDescPro9Label',
    memberDescPro10Label: 'subscribe.memberDescPro10Label',
    stripeConfirmMessage1: 'subscribe.stripeConfirmMessage1',
    stripeConfirmMessage2: 'subscribe.stripeConfirmMessage2',
    stripeConfirmMessage3: 'subscribe.stripeConfirmMessage3',
    stripeConfirmMessage3Local: 'subscribe.stripeConfirmMessage3Local',
    stripeConfirmMessage4: 'subscribe.stripeConfirmMessage4',
    stripeSuccessMessage: 'subscribe.stripeSuccessMessage',
    stripeFailedMessage: 'subscribe.stripeFailedMessage',
    stripeConfirmButtonText: 'subscribe.stripeConfirmButtonText',
    stripeCancelButtonText: 'subscribe.stripeCancelButtonText',
    stripeEditBillingMessage: 'subscribe.stripeEditBillingMessage',
    stripeEditBillingConfirmButtonText: 'subscribe.stripeEditBillingConfirmButtonText',
    stripeUpgradeMessage: 'subscribe.stripeUpgradeMessage',
    stripeUpgradeSuccessMessage: 'subscribe.stripeUpgradeSuccessMessage',
    stripeSubscribeRenewButtonText: 'subscribe.stripeSubscribeRenewButtonText',
    stripeSubscribeRenewConfirmMessage: 'subscribe.stripeSubscribeRenewConfirmMessage',
    stripeSubscribeRenewSuccessMessage: 'subscribe.stripeSubscribeRenewSuccessMessage',
    stripeSubscribeCancelButtonText: 'subscribe.stripeSubscribeCancelButtonText',
    stripeSubscribeCancelConfirmMessage: 'subscribe.stripeSubscribeCancelConfirmMessage',
    stripeSubscribeCancelSuccessMessage: 'subscribe.stripeSubscribeCancelSuccessMessage',
    cancelQuestionaireTitle: 'subscribe.cancelQuestionaireTitle',
    cancelQuestionaireSubject: 'subscribe.cancelQuestionaireSubject',
    cancelQuestionaireSelection1: 'subscribe.cancelQuestionaireSelection1',
    cancelQuestionaireSelection2: 'subscribe.cancelQuestionaireSelection2',
    cancelQuestionaireSelection3: 'subscribe.cancelQuestionaireSelection3',
    cancelQuestionaireSelection4: 'subscribe.cancelQuestionaireSelection4',
    cancelQuestionaireSelection5: 'subscribe.cancelQuestionaireSelection5',
    cancelQuestionaireSelection6: 'subscribe.cancelQuestionaireSelection6',
    cancelQuestionaireSelection7: 'subscribe.cancelQuestionaireSelection7',
    cancelQuestionaireSelection8: 'subscribe.cancelQuestionaireSelection8',
    cancelQuestionaireSubmiteButtonText: 'subscribe.cancelQuestionaireSubmiteButtonText',
    cancelQuestionaireCancelButtonText: 'subscribe.cancelQuestionaireCancelButtonText',
    cancelSuccessMainTitle: 'subscribe.cancelSuccessMainTitle',
    cancelSuccessSubject: 'subscribe.cancelSuccessSubject',
    reactivateTitle: 'subscribe.reactivateTitle',
    reactivateSubject: 'subscribe.reactivateSubject',
    reactivateButtonText: 'subscribe.reactivateButtonText',
    upgradeTitle: 'subscribe.upgradeTitle',
    upgradeSubject: 'subscribe.upgradeSubject',
    upgradeDesc: 'subscribe.upgradeDesc',
    qrcodeTimeout: 'subscribe.qrcodeTimeout',
    clickToRefresh: 'subscribe.clickToRefresh',
    cycleText: 'subscribe.cycleText',
    cycleTextLocal: 'subscribe.cycleTextLocal',
    oneTimeText: 'subscribe.oneTimeText',
    yearlyText: 'subscribe.yearlyText',
    paymentTypeMonthlyText: 'subscribe.paymentTypeMonthlyText',
    paymentTypeYearlyText: 'subscribe.paymentTypeYearlyText',
    cycleTextFirst: 'subscribe.cycleTextFirst',
    alipayCancelConfirmMessage1: 'subscribe.alipayCancelConfirmMessage1',
    alipayCancelConfirmMessage2: 'subscribe.alipayCancelConfirmMessage2',
    alipayCancelConfirmButtonText: 'subscribe.alipayCancelConfirmButtonText',
    alipayCancelConfirmCancelButtonText: 'subscribe.alipayCancelConfirmCancelButtonText',
    freeUsageText: 'subscribe.freeUsageText',
    currentSubscription: 'subscribe.currentSubscription',
    expiredText: 'subscribe.expiredText',
    subscriptionPolicyText: 'subscribe.subscriptionPolicyText'
  },
  similer: {
    similerTitle: 'similer.similerTitle',
    similerWaitingMessage: 'similer.similerWaitingMessage',
    similerSearchFailedMessage: 'similer.similerSearchFailedMessage',
    similerNoSimilarMessage: 'similer.similerNoSimilarMessage',
    similerLoadingMoreDetailImageError: 'similer.similerLoadingMoreDetailImageError'
  },
  taskType: {
    generate: 'taskType.generate',
    upscale: 'taskType.upscale',
    realtimeDesign: 'taskType.realtimeDesign'
  },
  rewardTask: {
    rewardTaskListTitle1: 'rewardTask.rewardTaskListTitle1',
    rewardTaskListTitle1Intl: 'rewardTask.rewardTaskListTitle1Intl',
    rewardTaskListDesc1: 'rewardTask.rewardTaskListDesc1',
    rewardTaskListGuide1: 'rewardTask.rewardTaskListGuide1',
    rewardTaskListDesc2: 'rewardTask.rewardTaskListDesc2',
    rewardTaskListGuide2: 'rewardTask.rewardTaskListGuide2',
    rewardTaskListDesc3: 'rewardTask.rewardTaskListDesc3',
    rewardTaskListGuide3: 'rewardTask.rewardTaskListGuide3',
    rewardTaskListDesc4: 'rewardTask.rewardTaskListDesc4',
    rewardTaskListGuide4: 'rewardTask.rewardTaskListGuide4',
    rewardTaskListDesc5: 'rewardTask.rewardTaskListDesc5',
    rewardTaskListGuide5: 'rewardTask.rewardTaskListGuide5',
    rewardTaskListDesc6: 'rewardTask.rewardTaskListDesc6',
    rewardTaskListGuide6: 'rewardTask.rewardTaskListGuide6',
    rewardTaskListDesc7: 'rewardTask.rewardTaskListDesc7',
    rewardTaskListGuide7: 'rewardTask.rewardTaskListGuide7',
    getRewardButtonText1: 'rewardTask.getRewardButtonText1',
    getRewardButtonText1Local: 'rewardTask.getRewardButtonText1Local',
    sketchToImageInitPrompt: 'rewardTask.sketchToImageInitPrompt',
    sketchToImageColorInitPrompt: 'rewardTask.sketchToImageColorInitPrompt',
    styleExtensionInitPrompt: 'rewardTask.styleExtensionInitPrompt',
    styleFusionInitPrompt: 'rewardTask.styleFusionInitPrompt',
    text2ImageInitPrompt: 'rewardTask.text2ImageInitPrompt',
    limitTime: 'rewardTask.limitTime',
    guideStartButtonText: 'rewardTask.guideStartButtonText',
    currentSubscription: 'rewardTask.currentSubscription',
    confirmCloseDialogTitle: 'rewardTask.confirmCloseDialogTitle',
    confirmCloseDialogDesc: 'rewardTask.confirmCloseDialogDesc',
    confirmCloseDialogCancelButtonText: 'rewardTask.confirmCloseDialogCancelButtonText',
    confirmCloseDialogConfirmButtonText: 'rewardTask.confirmCloseDialogConfirmButtonText',
    rewardTitle: 'rewardTask.rewardTitle',
    rewardDescription: 'rewardTask.rewardDescription',
    discountUnit: 'rewardTask.discountUnit',
    couponType1: 'rewardTask.couponType1',
    couponType2: 'rewardTask.couponType2',
    expiredText: 'rewardTask.expiredText',
    useNow: 'rewardTask.useNow'
  },
  contextMenu: {
    copy: 'contextMenu.copy',
    paste: 'contextMenu.paste',
    selectAll: 'contextMenu.selectAll'
  },
  remainingBalance: {
    realTimeDesign: 'remainingBalance.realTimeDesign',
    minute: 'remainingBalance.minute',
    hour: 'remainingBalance.hour',
    frequency: 'remainingBalance.frequency',
    upscale: 'remainingBalance.upscale',
    last: 'remainingBalance.last',
    image: 'remainingBalance.image',
    unlimited: 'remainingBalance.unlimited'
  },
  compositor: {
    opacity: 'compositor.opacity',
    saturation: 'compositor.saturation',
    brightness: 'compositor.brightness',
    contrast: 'compositor.contrast',
    hue: 'compositor.hue',
    depthMapFailed: 'compositor.depthMapFailed'
  },
  coupon: {
    couponListTitle: 'coupon.couponListTitle',
    couponExpireCountdown: 'coupon.couponExpireCountdown',
    couponExpire: 'coupon.couponExpire',
    couponListEmpty: 'coupon.couponListEmpty',
    couponListEmptyDescription1: 'coupon.couponListEmptyDescription1',
    couponListEmptyDescription2: 'coupon.couponListEmptyDescription2',
    couponListEmptyButton: 'coupon.couponListEmptyButton'
  },
  plugins: {
    pluginsTitle: 'plugins.pluginsTitle',
    addPluginButtonText: 'plugins.addPluginButtonText',
    removePluginButtonText: 'plugins.removePluginButtonText',
    addedPluginButtonText: 'plugins.addedPluginButtonText',
    noImages: 'plugins.noImages',
    noPluginComponentText: 'plugins.noPluginComponentText',
    editPluginsButtonText: 'plugins.editPluginsButtonText',
    editPluginsCompletedButtonText: 'plugins.editPluginsCompletedButtonText',
    morePluginsButtonText: 'plugins.morePluginsButtonText',
    removePluginTipsTitle: 'plugins.removePluginTipsTitle',
    removePluginTips1: 'plugins.removePluginTips1',
    removePluginTips2: 'plugins.removePluginTips2',
    pluginDisabled: 'plugins.pluginDisabled',
    pluginsTips: {
      title: 'plugins.pluginsTips.title',
      subtitle: 'plugins.pluginsTips.subtitle',
      subtitle2: 'plugins.pluginsTips.subtitle2',
      plugintipTitle1: 'plugins.pluginsTips.plugintipTitle1',
      plugintipDesc1: 'plugins.pluginsTips.plugintipDesc1',
      plugintipTitle2: 'plugins.pluginsTips.plugintipTitle2',
      plugintipDesc2: 'plugins.pluginsTips.plugintipDesc2',
      plugintipDesc2Desc1: 'plugins.pluginsTips.plugintipDesc2Desc1',
      plugintipDesc2Desc2: 'plugins.pluginsTips.plugintipDesc2Desc2',
      plugintipDesc2Desc3: 'plugins.pluginsTips.plugintipDesc2Desc3',
      plugintipDesc2Desc3Link: 'plugins.pluginsTips.plugintipDesc2Desc3Link',
      plugintipTitle3: 'plugins.pluginsTips.plugintipTitle3',
      plugintipDesc3: 'plugins.pluginsTips.plugintipDesc3',
      plugintipDesc3Desc1: 'plugins.pluginsTips.plugintipDesc3Desc1',
      plugintipDesc3Desc2: 'plugins.pluginsTips.plugintipDesc3Desc2',
      plugintipDesc3DescFooter: 'plugins.pluginsTips.plugintipDesc3DescFooter'
    },
    pluginsTipsFooter: {
      discord: 'plugins.pluginsTipsFooter.discord',
      instagram: 'plugins.pluginsTipsFooter.instagram',
      email: 'plugins.pluginsTipsFooter.email'
    }
  },
  guide: {
    guideTitleVideo: 'guide.guideTitleVideo',
    guideTitleBook: 'guide.guideTitleBook',
    guideTitleSmallGift: 'guide.guideTitleSmallGift',
    guideTitleSmallGiftDesc1: 'guide.guideTitleSmallGiftDesc1',
    guideTitleSmallGiftDesc2: 'guide.guideTitleSmallGiftDesc2',
    guideTitleSmallGiftDesc3: 'guide.guideTitleSmallGiftDesc3',
    guideTitleSmallGiftDesc4: 'guide.guideTitleSmallGiftDesc4'
  },
  token: {
    usageDialogTitle: 'token.usageDialogTitle',
    creditsTitle: 'token.creditsTitle',
    dailyCredits: 'token.dailyCredits',
    planCredits: 'token.planCredits',
    campaignCredits: 'token.campaignCredits',
    extraCredits: 'token.extraCredits',
    buyMoreCreditsButtonText: 'token.buyMoreCreditsButtonText',
    detailTableTitle: 'token.detailTableTitle',
    detailTableDate: 'token.detailTableDate',
    detailTableCreditChange: 'token.detailTableCreditChange',
    usage: 'token.usage',
    claimVoucher: 'token.claimVoucher',
    buyMoreCreditsDialogTitle: 'token.buyMoreCreditsDialogTitle',
    buyMoreCreditsDialogDesc1: 'token.buyMoreCreditsDialogDesc1',
    buyMoreCreditsDialogDesc2: 'token.buyMoreCreditsDialogDesc2',
    buyMoreCreditsDialogButtonText: 'token.buyMoreCreditsDialogButtonText',
    buyingCredits: 'token.buyingCredits',
    creditsRule: 'token.creditsRule',
    discount: 'token.discount',
    inPlanCredits: 'token.inPlanCredits',
    dailyCreditsTips: 'token.dailyCreditsTips',
    expriredAt: 'token.expriredAt',
    buyCreditsSuccessText: 'token.buyCreditsSuccessText'
  },
  styleImagePrinting: {
    title: 'styleImagePrinting.title',
    uploadStyleImage: 'styleImagePrinting.uploadStyleImage',
    uploadPrintImage: 'styleImagePrinting.uploadPrintImage',
    printImageSize: 'styleImagePrinting.printImageSize',
    promptExample: 'styleImagePrinting.promptExample'
  },
  announcementTips: {
    title: 'announcementTips.title',
    subtitle: 'announcementTips.subtitle',
    subtitle2: 'announcementTips.subtitle2',
    plugintipTitle1: 'announcementTips.plugintipTitle1',
    plugintipDesc1: 'announcementTips.plugintipDesc1',
    plugintipTitle2: 'announcementTips.plugintipTitle2',
    plugintipDesc2: 'announcementTips.plugintipDesc2',
    plugintipDesc2Desc1: 'announcementTips.plugintipDesc2Desc1',
    plugintipDesc2Desc2: 'announcementTips.plugintipDesc2Desc2',
    plugintipDesc2Desc3: 'announcementTips.plugintipDesc2Desc3',
    plugintipDesc2Desc3Link: 'announcementTips.plugintipDesc2Desc3Link',
    plugintipTitle3: 'announcementTips.plugintipTitle3',
    plugintipDesc3: 'announcementTips.plugintipDesc3',
    plugintipDesc3Desc1: 'announcementTips.plugintipDesc3Desc1',
    plugintipDesc3Desc2: 'announcementTips.plugintipDesc3Desc2',
    plugintipDesc3DescFooter: 'announcementTips.plugintipDesc3DescFooter'
  },
  preAnnouncementTips: {
    title: 'preAnnouncementTips.title',
    subtitle: 'preAnnouncementTips.subtitle',
    subHeader: 'preAnnouncementTips.subHeader',
    tipTitle1: 'preAnnouncementTips.tipTitle1',
    tipDesc1: 'preAnnouncementTips.tipDesc1',
    tipTitle2: 'preAnnouncementTips.tipTitle2',
    tipDesc2: 'preAnnouncementTips.tipDesc2',
    tipDesc2Item1: 'preAnnouncementTips.tipDesc2Item1',
    tipDesc2Item2: 'preAnnouncementTips.tipDesc2Item2',
    tipDesc2Item3: 'preAnnouncementTips.tipDesc2Item3',
    tipTitle3: 'preAnnouncementTips.tipTitle3',
    tipDesc3: 'preAnnouncementTips.tipDesc3',
    noticeText: 'preAnnouncementTips.noticeText'
  },
  limited: {
    title: 'limited.title',
    titleMax: 'limited.titleMax',
    subtitle: 'limited.subtitle',
    subject: 'limited.subject',
    listTitle: 'limited.listTitle',
    listItem1: 'limited.listItem1',
    listItem2: 'limited.listItem2',
    listItem3: 'limited.listItem3',
    listItem4: 'limited.listItem4',
    listItem5: 'limited.listItem5',
    promise: 'limited.promise',
    allPlan: 'limited.allPlan'
  }
}

export enum Scope {
  unknown,
  zh,
  hk_macao,
  tw,
  intl
}
